import * as React from 'react';
import { clsx } from 'clsx';
import styles from '../../../internal/styles/inputWrapperGroup.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Компонента для объединения нескольких элементов форм из кита в горизонтальную группу
 *
 * Список поддерживаемых элементов:
 * * Input
 * * Select
 * * SelectDesktop
 * * SelectMobile
 * * MultiSelect
 * * MultiSelectDesktop
 * * MultiSelectMobile
 */
export function InputGroup(_ref) {
  let {
    inline,
    spliced,
    width,
    minWidth,
    maxWidth,
    children
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: clsx(styles['input-wrapper-group'], spliced && styles['spliced'], inline && styles['inline']),
    style: {
      width,
      minWidth,
      maxWidth
    },
    children: children
  });
}